@for (
  customField of form.controls;
  track customField.value.label;
  let index = $index, count = $count, last = $last
) {
  <div [formGroup]="customField" appValidationContext class="row gx-2">
    <div class="col input-group mb-1">
      <input
        data-dd-action-name="custom-fields-edit.label-input"
        #typeAheadInput
        appFormControl
        formControlName="label"
        [ngbTypeahead]="search"
        [resultTemplate]="resultTemplate"
        container="body"
        type="text"
        placeholder="Custom name&hellip;"
        (blur)="onBlur(index)"
        (focus)="onLabelFocus($event)"
      />
      <ng-template #resultTemplate let-key="result">
        <div class="typeahead-item">
          <span>{{ key }}</span>
          <button
            data-dd-action-name="custom-fields-edit.delete-label-button"
            type="button"
            class="btn"
            (click)="deleteKey(key, typeAheadInput)"
          >
            <i-lucide name="trash2"></i-lucide>
          </button>
        </div>
      </ng-template>
      <span class="input-group-text">:</span>
      <input
        data-dd-action-name="custom-fields-edit.value-input"
        appFormControl
        formControlName="value"
        type="text"
        class="rounded-end"
        placeholder="Custom value&hellip;"
        (blur)="onBlur(index)"
      />
    </div>

    <div class="col flex-grow-0">
      @if (count > 1) {
        <button
          data-dd-action-name="custom-fields-edit.delete-field-button"
          type="button"
          class="btn btn-danger-outline ms-1"
          (click)="delete(index)"
          [disabled]="last"
        >
          <i-lucide name="trash2"></i-lucide>
        </button>
      }
    </div>

    <div *invalidMessageFor="'maxlength' as error">
      Input must be less than {{ error.requiredLength }} characters
    </div>
    <div *invalidMessageFor="'duplicateLabel' as error">
      Duplicate label {{ error.value }}
    </div>
  </div>
}
